export const REPLACE_PERSONS = 'REPLACE_PERSONS';
export const ADD_PERSON = 'ADD_PERSON';
export const UPDATE_PERSON = 'UPDATE_PERSON';